module.exports = __webpack_public_path__ + "static/media/yannick.e2b276b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PublicWebsite/SocialProof/yannick.jpg
// module id = 522
// module chunks = 0